import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  CLICK_ADD_FEE: '6910',
  CLICK_EDIT_FEE: '6911',
  CLICK_DELETE_FEE: '6912',
} as const;

// https://dataportal.zillowgroup.net/event-registry/6910
const ClickAddFee = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: string;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_ADD_FEE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'button_to_add_fee',
    },
    semantic: {
      semantic_event_nm: 'add_fee',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6911
const ClickEditFee = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: string;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_EDIT_FEE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'button_to_edit_fee',
    },
    semantic: {
      semantic_event_nm: 'edit_fee',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6912
const ClickDeleteFee = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: string;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_DELETE_FEE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'button_to_delete_fee',
    },
    semantic: {
      semantic_event_nm: 'delete_fee',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const CostsAndFeesSFCSEvents = {
  ClickAddFee,
  ClickEditFee,
  ClickDeleteFee,
};

// Clickstream visualizer data-eventid attributes
ClickAddFee.data_event_id = EVENT_IDS.CLICK_ADD_FEE;
ClickEditFee.data_event_id = EVENT_IDS.CLICK_EDIT_FEE;
ClickDeleteFee.data_event_id = EVENT_IDS.CLICK_DELETE_FEE;

export default CostsAndFeesSFCSEvents;
